<template>
  <div>
    <el-form style="position: relative;" ref="formName" label-width="70px" :inline="true" class="login-container" :model="form" :rules="rules">
		<div class="black" @click="btnGohome">
			<img class="black_img" src="/img/black.png" alt="" />
			返回
		</div>
		<div style="padding-bottom: 81px;padding-left: 50px;">请用报单[联系人手机号]进行登录 查看报单状态</div>
      <!-- <h3 class="login_title">手机验证码登录</h3> -->

		<div style="text-align: center;">
			<el-form-item label="手机号" prop="CellPhone" ref="phone">
			  <el-input style="width: 300px;" v-model="form.CellPhone" placeholder="请输入手机号">
			    <el-select placeholder="+86"></el-select>
			  </el-input>
			</el-form-item>
			
			<el-form-item label="验证码" prop="VerificationCode">
			  <el-input style="width: 300px;" v-model="form.VerificationCode" placeholder="请输入验证码">
			    <el-button slot="suffix" class="getCode_bom" :disabled="disabled" @click="getCode">
			      <span class="Time">{{btnTxt}}</span>
			    </el-button>
			  </el-input>
			</el-form-item>
		</div>

      <div class="buttom_btn">
        <el-button @click="submit" type="primary" class="login_btn" :disabled="loginBtn">登录</el-button>
      </div>
	  <el-dialog style="margin-top: 20vh;"
	    title="温馨提示"
	    :visible.sync="dialogShow"
	    width="30%"
	    center>
	    <div style="display: flex;flex-direction: column;align-items: center;">
			<div>未查到手机号企业报单记录</div>
			<div>请前往“企业信息填报”页面进行报单</div>
		</div>
	    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-around;">
	      <el-button @click="dialogShow = false" type="info">取 消</el-button>
	      <el-button @click="btnGoindex" type="primary">去填报企业信息</el-button>
	    </span>
	  </el-dialog>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'));
      }
      if (!/^1[35789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'));
      }
      callback();
    };

    return {
      btnTxt: '获取验证码',
      disabled: false,
      loginBtn: false,
	  dialogShow:false,
      time: 0,
      form: {
        CellPhone: '',
        VerificationCode: '',
      },
      rules: {
        CellPhone: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入11位手机号',
          },
          {
            required: true,
            trigger: 'blur',
            min: 11,
            max: 11,
            message: '长度不符合',
          },
          {
            required: true,
            trigger: 'blur',
            validator: validatePhone,
          },
        ],
        VerificationCode: [
          {
               required: true,
               trigger: 'blur',
               message: '请输入验证码',
             },
		  {
		        validator: this.validateVerificationCode,
		      }
        ],
      },
    };
  },
  methods: {
	   validateVerificationCode(rule, value, callback) {
	       if (value === "dfzt123456") {
	         callback();
	       } else {
	         // 否则检查验证码长度是否为4位
	         if (value.length !== 4) {
	           callback(new Error('验证码长度必须为4位'));
	         } else {
	           callback();
	         }
	       }
	     },
	  btnGoindex(){
			this.$router.push('/index')
	  },
	  btnGohome(){
		  this.$router.push('/home')
	  },
    getCode() {
      if (!this.form.CellPhone) {
        this.$message({
          message: '请输入手机号',
          type: 'warning',
        });
      } else if (!/1[35789]\d{9}/.test(this.form.CellPhone)) {
      } else {
        this.time = 60;
        this.disabled = true;
        this.$axios
          .get('/open/v1/customers/send_sms', {
            params: {
              phoneNumber: this.form.CellPhone,
            },
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.data,
                type: 'success',
              });
			  this.timer();
            } else {
				this.$message({
				  message: res.data.message,
				  type: 'warning',
				});
				if(res.data.code==4001){
					this.dialogShow=true
					this.disabled = false;
				}
            
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btnTxt = this.time + 's后重发';
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btnTxt = '获取验证码';
        this.disabled = false;
      }
    },
    submit() {
      this.$refs['formName'].validate((valid) => {
        if (valid) {
          this.loginBtn = true;
          this.$axios
            .get(`/open/v1/customers/linkPhone/${this.form.CellPhone}`, {
              params: {
                code: this.form.VerificationCode,
              },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: res.data.message,
                  type: 'success',
                });
                localStorage.setItem('userId', res.data.data.id);
               this.$router.push({
                 path: '/taxationTag',
                 query: {
                   id: res.data.data.id // 替换成你要传递的id值
                 }
               })
              } else {
                this.$message({
                  message: res.data.message,
                  type: 'error',
                });
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally((fin) => {
              this.loginBtn = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
	.black{
		 position: absolute;top: 10px;left: 10px;cursor: pointer;    display: flex;align-items: center;
		 .black_img{
			 width: 20px;height: 20px;border-radius: 20px;padding-right: 5px;
		 }
	}
.login-container {
  width: 500px;
  border: 1px solid #eaeaea;
  margin: 180px auto;
  padding: 55px 35px 35px 35px;
  border-radius: 15px;
  box-shadow: 0 0 25px #cac6c6;
  background-color: #ffffff;
  box-sizing: border-box;

  .el-input__inner {
    width: 300px;
  }
  .getCode_bom {
    border: 0px;
    margin-right: -4px;
  }

  .el-button .span {
    margin-left: 50px;
  }

  .login_title {
    text-align: center;
    margin-bottom: 40px;
    color: #505458;
  }

  .el-input {
    width: 198px;
  }

  .login_button {
    margin-left: 105px;
    margin-top: 10px;
  }

  .time {
    width: 50px;
  }

  .buttom_btn {
    display: flex;
    justify-content: center;

    .login_btn {
      width: 40%;
    }
  }

  .el-form-item {
    margin-bottom: 50px;
  }
}
</style>
